import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { FormData, FormProviderService, PreventDoubleSubmission } from '@fry/lib/forms';
import { User, UsersStore } from '@fry/lib/users';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';


@Injectable()
export class UserEditBasicForm {

    private formData: FormData;

    constructor(
        private provider: FormProviderService,
        private users: UsersStore
    ) { }

    private options = { submitTitle: $localize `Save Profile` };

    _fields = [
        { id: 'firstName', title: $localize `First name`, initial: '',
          widget: { type: 'string', autocomplete: 'given-name' },
          validators: [Validators.required] },
        { id: 'lastName', title: $localize `Last name`, initial: '',
          widget: { type: 'string', autocomplete: 'family-name' },
          validators: [Validators.required] }
    ];

    init(user: User): Observable<FormData> {
        return this.provider.getFormDataWith(this._fields, user.doc, this.options).pipe(
            tap(formData => this.formData = formData)
        );
    }

    @PreventDoubleSubmission()
    submit(user: User): Observable<User> {
        if (this.formData.invalid) {
            return throwError($localize `Please review the form`);
        }

        const value = this.formData.getValue();
        return this.users.updateBasic(user, value);
    }

    get pristine() {
        if (!this.formData) {
            return true;
        }
        return this.formData.pristine;
    }


}
